module.exports = __webpack_public_path__ + "img/mic.8924c881.png";